import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\WorkspaceSelectController::select
* @see app/Http/Controllers/Admin/WorkspaceSelectController.php:11
* @route '/workspaces/{workspace}/select'
*/
export const select = (args: { workspace: string | { id: string } } | [workspace: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: select.url(args, options),
    method: 'post',
})

select.definition = {
    methods: ["post"],
    url: '/workspaces/{workspace}/select',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\WorkspaceSelectController::select
* @see app/Http/Controllers/Admin/WorkspaceSelectController.php:11
* @route '/workspaces/{workspace}/select'
*/
select.url = (args: { workspace: string | { id: string } } | [workspace: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { workspace: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { workspace: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            workspace: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        workspace: typeof args.workspace === 'object'
        ? args.workspace.id
        : args.workspace,
    }

    return select.definition.url
            .replace('{workspace}', parsedArgs.workspace.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\WorkspaceSelectController::select
* @see app/Http/Controllers/Admin/WorkspaceSelectController.php:11
* @route '/workspaces/{workspace}/select'
*/
select.post = (args: { workspace: string | { id: string } } | [workspace: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: select.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\WorkspaceSelectController::select
* @see app/Http/Controllers/Admin/WorkspaceSelectController.php:11
* @route '/workspaces/{workspace}/select'
*/
const selectForm = (args: { workspace: string | { id: string } } | [workspace: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: select.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\WorkspaceSelectController::select
* @see app/Http/Controllers/Admin/WorkspaceSelectController.php:11
* @route '/workspaces/{workspace}/select'
*/
selectForm.post = (args: { workspace: string | { id: string } } | [workspace: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: select.url(args, options),
    method: 'post',
})

select.form = selectForm

/**
* @see \App\Http\Controllers\Admin\WorkspaceController::store
* @see app/Http/Controllers/Admin/WorkspaceController.php:27
* @route '/workspaces'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/workspaces',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\WorkspaceController::store
* @see app/Http/Controllers/Admin/WorkspaceController.php:27
* @route '/workspaces'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\WorkspaceController::store
* @see app/Http/Controllers/Admin/WorkspaceController.php:27
* @route '/workspaces'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\WorkspaceController::store
* @see app/Http/Controllers/Admin/WorkspaceController.php:27
* @route '/workspaces'
*/
const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\WorkspaceController::store
* @see app/Http/Controllers/Admin/WorkspaceController.php:27
* @route '/workspaces'
*/
storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

store.form = storeForm

const workspaces = {
    select: Object.assign(select, select),
    store: Object.assign(store, store),
}

export default workspaces